// @ts-nocheck
import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Configuration";
import "@store/Framework/Store";
import "@store/Themes";
import "@toolkit/initialize";

// load all widgets. Without this they won't be included in the bundle
const widgets = require.context("./Library/Widgets", true, /\.tsx$/);
const onHotWidgetReplace = addWidgetsFromContext(widgets);
if (module.hot) {
    module.hot.accept(widgets.id.toString(), () =>
        onHotWidgetReplace(require.context("./Library/Widgets", true, /\.tsx$/)),
    );
}

// load all pages. Without this they won't be included in the bundle
const pages = require.context("./Library/Pages", true, /\.tsx$/);
const onHotPageReplace = addPagesFromContext(pages);
if (module.hot) {
    module.hot.accept(pages.id.toString(), () => onHotPageReplace(require.context("./Library/Pages", true, /\.tsx$/)));
}

// load all extensions. They could be loaded individually instead.
const extensions = require.context("./Extensions", true);
extensions.keys().forEach(key => extensions(key));
